import { useSlate } from 'slate-react';
import ColorPicker from '../../../../../RichTextEditorV2/Elements/ColorPicker/ColorPicker';

export const FontColorTool = () => {
  const editor = useSlate();
  return <ColorPicker format="color" editor={editor} />;
};
